import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, Input, signal } from '@angular/core';

import { ApiResponse } from '../../../../core/models/api.model';
import { PlanEmpresa } from '../../../../core/models/plan.model';
import { PlanService } from '../../../../core/services/plan.service';
import { LoadingComponent } from '../../../../shared/loading/loading';
import { UiButtonComponent } from '../../../../shared/ui-button/ui-button';

@Component({
  selector: 'app-empresas-suscritas',
  standalone: true,
  imports: [DatePipe, LoadingComponent, UiButtonComponent],
  templateUrl: './empresas.html',
  styleUrl: './empresas.css',
})
export class EmpresasSuscritasComponent {
  @Input() planId: string | null = null;
  @Input() planName = '';

  private readonly planService = inject(PlanService);
  protected readonly loading = signal(false);
  protected readonly loadError = signal('');
  protected readonly companies = signal<PlanEmpresa[]>([]);

  ngOnChanges(): void {
    this.loadCompanies();
  }

  protected loadCompanies(): void {
    if (!this.planId) {
      this.companies.set([]);
      this.loadError.set('No se recibió el plan seleccionado.');
      return;
    }

    this.loading.set(true);
    this.loadError.set('');

    this.planService.getEmpresas(this.planId).subscribe({
      next: (companies) => {
        this.companies.set(companies);
        this.loading.set(false);
      },
      error: (error: HttpErrorResponse) => {
        this.loadError.set(
          this.getApiErrorMessage(error, 'No se pudieron cargar las empresas suscritas.'),
        );
        this.loading.set(false);
      },
    });
  }

  private getApiErrorMessage(error: HttpErrorResponse, fallback: string): string {
    const response = error.error as ApiResponse<unknown> | string | null;

    if (typeof response === 'string') return response.trim() || fallback;
    if (!response) return fallback;
    if (response.message?.trim()) return response.message;

    const firstError = response.errors?.find((item) => item.message?.trim());
    return firstError?.message ?? fallback;
  }
}
